import {
    GET_CURRENCY_RATE,
    GET_CURRENCY_RATE_ERROR,
    GET_CURRENCY_RATE_SUCCESS
} from "../actions/currencyAction";

const initialState = {
    currencyRate: [],
    loading: false,
    loaded: false,
    error: null,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_CURRENCY_RATE:
            return {
                ...state,
                loading: true,
                loaded: false,
                error: null,
            };

        case GET_CURRENCY_RATE_SUCCESS:
            return {
                ...state,
                loading: false,
                loaded: true,
                currencyRate: action.payload.success,
            };

        case GET_CURRENCY_RATE_ERROR:
            return {
                ...state,
                loading: false,
                loaded: false,
                error: action.payload.error,
                currencyRate: [],
            };

        default:
            return state;
    }
}
